import {GroupNameToInputName} from '../../advertisementList/utils';
import {FromikType} from '../types';

export const buyHandleDescriptionText = (
  values: FromikType,
  input_group?: string,
  sub_input?: string,
): Record<string, string> => {
  return {
    fertilizer: `به ${values?.wanted_weight || ''} ${[
      values.weight_unit?.title,
    ]} ${input_group && GroupNameToInputName[input_group]} از نوع ${
      sub_input || ''
    } نیاز دارم.`,
    pesticide: `به ${values?.wanted_weight || ''} ${[
      values.weight_unit?.title,
    ]} ${input_group && GroupNameToInputName[input_group]} از نوع ${
      sub_input || ''
    } نیاز دارم.`,
    seed: `به ${values?.wanted_weight || ''} ${[values.weight_unit?.title]} ${
      input_group && GroupNameToInputName[input_group]
    } از نوع ${sub_input || ''} نیاز دارم.`,
    tool: `به ${values?.wanted_number || ''} ${
      values?.weight_unit?.title || 'عدد'
    } ${input_group && GroupNameToInputName[input_group]} از نوع ${
      sub_input || ''
    } نیاز دارم.`,
    machinery: `به ${values?.wanted_number || ''} دستگاه ${
      input_group && GroupNameToInputName[input_group]
    } مدل ${sub_input || ''} نیاز دارم.`,
    farm11: `به ${values?.area || ''} ${values?.area_unit?.title} ${
      sub_input || ''
    } نیاز دارم.`,
    farm13: `به خرید حق آبه از نوع ${
      handleFarmDescriptionChange(values?.sub_input?.title) || ''
    } به مدت ${values?.renting_duration || ''} ${
      values?.renting_duration_unit?.title
    } نیاز دارم.`,
  };
};

export const serviceHandleDescriptionText = (
  values: FromikType,
  sub_input?: string,
  wanted_number?: number,
  input?: string,
): Record<string, string> => {
  return {
    machinery: ` به خدمات ${
      sub_input || ''
    } برای  ${wanted_number} هکتار مزرعه ${
      values.cultivation?.title || ''
    } نیاز دارم.`,
    employee: ` به  ${wanted_number} ${input} ${sub_input || ''} به مدت  ${
      values?.employing_duration
    } ${values?.employing_duration_unit?.title}  نیاز دارم.`,
    lab: `به یک آزمایشگاه جهت آزمایش ${sub_input || ''} نیاز دارم.`,
  };
};

export const rentHandleDescriptionText = (
  values: FromikType,
  sub_input?: string,
  wanted_number?: number,
): Record<string, string> => {

  return {
    machinery: `به ${wanted_number} دستگاه ${sub_input || ''} به مدت ${
      values?.requirement_during || ''
    } ${values?.request_date_unit?.title} نیاز دارم.`,
    farm: `به${values?.area ? values?.area : ''} ${
      values?.area_unit ? values?.area_unit?.title : ''
    }${handleFarmDescriptionChange(sub_input || '', true)} به مدت${
      values.renting_duration ? values.renting_duration : ''
    } ${
      values?.renting_duration_unit?.title
        ? values?.renting_duration_unit?.title
        : ''
    } نیاز دارم.`,
  };
};

const handleFarmDescriptionChange = (
  desc: string,
  isRent?: boolean,
): string => {
  switch (desc) {
    case 'لایروبی':
      return 'آب لایروبی';

    case 'حق آبه (هزینه اشتراک)':
      if (isRent) return desc;
      return 'هزینه اشتراک';

    default:
      return desc;
  }
};
